import { useMemo } from "react";

const useFirstAvailableRoute = (tabsList, isTabActive, routeMapping) => {
  return useMemo(() => {
    if (!tabsList) return null;

    for (const [tab, route] of Object.entries(routeMapping)) {
      if (isTabActive(tabsList?.[tab])) return route;
    }

    return null;
  }, [tabsList, isTabActive, routeMapping]);
};

export default useFirstAvailableRoute;
